import React, {useEffect, useRef, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {Col, Row,} from "react-bootstrap";


const DetailVocContract = () => {
    const {id} = useParams()
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const componentRef = useRef();

    const [vOCContract, setVOCContract] = useState('')

    const getSingleVOCContract = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/voc_contract/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/voc_contract/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        setVOCContract(data)
    }

    useEffect(() => {
        getSingleVOCContract()
    }, [])

    return (
        <div style={{padding: '0', margin: '0'}}>
            <div
                id="section-to-print"
                className={'formcontainer, section-to-print'}
                ref={componentRef}
            >
                {/*<h1>Create Client {work_site_address}</h1>*/}
                <br/>
                <div style={{textAlign: "center"}}>
                    <Row>
                        <Col lg={2}>
                            <img
                                src={'letterHeadLogo.png'}
                                alt={'Letter Head Logo'}/>
                        </Col>
                        <Col>
                            <h1>VOC Diagnostic & Mitigation Proposal / Contract:</h1>

                            <p>
                                Home Safety Solutions Inc.
                            </p>


                            <p>
                                3140 Viking Blvd NE, East Bethel, MN 55092
                            </p>


                            <p>
                                (C) 612-490-1295 (O) 763-434-3263
                            </p>

                            <p>
                                walt@homesafetysolutionsinc.com
                            </p>
                        </Col>
                    </Row>
                </div>
                <br/>

                <Row style={{border: 'solid', margin: '0 .1px'}}>
                    <Col style={{borderRight: 'solid'}}>
                        Proposal Submitted To:
                        <p style={{textAlign: 'center'}}>
                            {vOCContract.proposal_submitted_to_company}<br/>
                            {vOCContract.proposal_submitted_to_client_name}<br/>
                            {vOCContract.proposal_submitted_to_title}<br/>
                            {vOCContract.proposal_submitted_to_phone}<br/>
                            {vOCContract.proposal_submitted_to_email}<br/>
                        </p>
                    </Col>
                    <Col>
                        <Row style={{borderBottom: 'solid'}}>
                            <Col>
                                Quoted Cost: <br/>
                                <p style={{textAlign: 'center'}}>
                                    $ {vOCContract.quoted_cost}
                                </p>

                            </Col>
                            <Col style={{borderLeft: 'solid'}}>
                                Proposal Date: <br/>
                                Pricing is valid for 90 days<br/>
                                <p style={{textAlign: 'center'}}>
                                    {vOCContract.proposal_date}
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Occupant(s) Name:<br/>
                                {vOCContract.occupants_name}
                            </Col>
                            <Col style={{borderLeft: 'solid'}}>
                                Job Location: <br/>
                                {vOCContract.job_location}
                            </Col>
                        </Row>
                    </Col>
                </Row>


                <div style={{borderLeft: 'solid', borderRight: 'solid', borderBottom: 'solid'}}>

                    <div>
                        <br/>
                        <h3 style={{
                            textAlign: 'center',
                            paddingBottom: "10px",
                            paddingLeft: '5px',
                            paddingRight: '5px'
                        }}>
                            Standard Services - VOC Mitigation (Sub Slab Depressurization) Of the entire building. This
                            is a preliminary estimate prior to any diagnostic data.
                            Many things can influence the cost of SSD systems, cement thickness, integrity, expansion
                            joints, footings, and sub-slab material as well as tenant access
                            and special requests.
                        </h3>

                        {
                            vOCContract.is_there_a_survey === "Yes"
                                ?
                                (
                                    <div>
                                        <h4 style={{padding: '0 10px'}}>
                                            Conduct an onsite interior building survey to evaluate building conditions
                                            prior to initialting SSD system install work -$
                                            {vOCContract.onsite_interior_survey_amount}
                                        </h4>
                                        <p style={{padding: '0 70px'}}>
                                            Includes interviewing property owners regarding building construction
                                            information, current building usage, and building conditions.
                                        </p>
                                    </div>
                                )
                                :
                                (
                                    ''
                                )
                        }

                        <p style={{padding: '0 10px'}}>
                            <h4>Pre-mitigation diagnostic testing - $</h4>
                            <ul>
                                <li>
                                    Includes all labor, equipment, and travel beyond mobilization to conduct
                                    pre-mitigation diagnostic
                                    testing for evaluating system components of installing an active SSD system.
                                </li>
                                <ul>
                                    {
                                        vOCContract.pre_mit_testing_step1
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step1}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step2
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step2}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step3
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step3}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step4
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step4}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step5
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step5}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step6
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step6}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step7
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step7}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step8
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step8}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step9
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step9}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step10
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step10}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step11
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step11}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step12
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step12}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step13
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step13}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step14
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step14}
                                            </li>
                                            :
                                            ('')
                                    }
                                    {
                                        vOCContract.pre_mit_testing_step15
                                            ?
                                            <li>
                                                {vOCContract.pre_mit_testing_step15}
                                            </li>
                                            :
                                            ('')
                                    }
                                </ul>
                            </ul>
                        </p>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            SSD System Installation - $
                        </h4>
                        <p>
                            Includes all labor, equipment, travel beyond mobilization, State and local building permits,
                            and estimated system components per the line
                            items below to install an active SSD system. If changes to the estimated system components
                            are required based on the diagnostic testing,
                            or building conditions a change order will be submitted for approval.
                        </p>
                        <p>
                            Mitigation systems to include:
                            <ul>
                                {
                                    vOCContract.ssd_system_step1
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step1}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step2
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step2}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step3
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step3}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step4
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step4}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step5
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step5}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step6
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step6}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step7
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step7}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step8
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step8}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step9
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step9}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step10
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step10}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step11
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step11}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step12
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step12}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step13
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step13}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step14
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step14}
                                        </li>
                                        :
                                        ('')
                                }
                                {
                                    vOCContract.ssd_system_step15
                                        ?
                                        <li>
                                            {vOCContract.ssd_system_step15}
                                        </li>
                                        :
                                        ('')
                                }
                            </ul>
                        </p>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            Post-Mitigation diagnostic testing and documentation - $
                            {vOCContract.post_mitigation_price}
                        </h4>
                        <p>
                            Includes all labor, equipment, travel beyond mobilization to conduct post-mitigation
                            diagnostic
                            testing for evaluating performance of the installed SDD system including pressure field
                            extension
                            testing, back-draft testing on all combustion appliances as feasible, completion of MPCA BMP
                            Checklists including Active Mitigation System Checklist and Post Mitigation Diagnostics
                            checklist.
                        </p>
                        <ul>
                            {
                                vOCContract.post_mitigation_step1
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step1}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step2
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step2}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step3
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step3}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step4
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step4}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step5
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step5}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step6
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step6}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step7
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step7}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step8
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step8}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step9
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step9}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step10
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step10}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step11
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step11}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step12
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step12}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step13
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step13}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step14
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step14}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.post_mitigation_step15
                                    ?
                                    <li>
                                        {vOCContract.post_mitigation_step15}
                                    </li>
                                    :
                                    ('')
                            }
                        </ul>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            Locations
                        </h4>
                        <p>
                            HSS will scan the floor to locate utilities (as needed) prior to any penetrations.
                        </p>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            Installation of additional suction pits
                        </h4>
                        <p>
                            Includes all labor, equipment, and supplies.

                        </p>
                        <ul>
                            <li>
                                If additional suction pits are needed per engineer or owners request additional charge
                                of
                                <big>
                                    ${vOCContract.price_installation_suction_pit}
                                </big>
                                per suction pit will apply
                            </li>
                        </ul>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            Sealing of floor cracks as potential vapor intrusion entry points to a building.
                        </h4>
                        <p>
                            Includes all costs for the sealing operation including labor and supplies to air-tight seal
                            floor cracks, cold joints, and foundation wall cracks.
                        </p>
                        <ul>
                            {
                                vOCContract.sealing_floor_cracks_step1
                                    ?
                                    <li>
                                        {vOCContract.sealing_floor_cracks_step1}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.sealing_floor_cracks_step2
                                    ?
                                    <li>
                                        {vOCContract.sealing_floor_cracks_step2}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.sealing_floor_cracks_step3
                                    ?
                                    <li>
                                        {vOCContract.sealing_floor_cracks_step3}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.sealing_floor_cracks_step4
                                    ?
                                    <li>
                                        {vOCContract.sealing_floor_cracks_step4}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.sealing_floor_cracks_step5
                                    ?
                                    <li>
                                        {vOCContract.sealing_floor_cracks_step5}
                                    </li>
                                    :
                                    ('')
                            }
                        </ul>
                        <h4>
                            System installation to be determined at the time of approval
                        </h4>
                    </div>

                    <div style={{padding: '0 10px'}}>
                        <h4>
                            Payment:
                        </h4>
                        <ul>
                            {
                                vOCContract.payment_step1
                                    ?
                                    <li>
                                        {vOCContract.payment_step1}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step2
                                    ?
                                    <li>
                                        {vOCContract.payment_step2}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step3
                                    ?
                                    <li>
                                        {vOCContract.payment_step3}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step4
                                    ?
                                    <li>
                                        {vOCContract.payment_step4}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step5
                                    ?
                                    <li>
                                        {vOCContract.payment_step5}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step6
                                    ?
                                    <li>
                                        {vOCContract.payment_step6}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step7
                                    ?
                                    <li>
                                        {vOCContract.payment_step7}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step8
                                    ?
                                    <li>
                                        {vOCContract.payment_step8}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step9
                                    ?
                                    <li>
                                        {vOCContract.payment_step9}
                                    </li>
                                    :
                                    ('')
                            }
                            {
                                vOCContract.payment_step10
                                    ?
                                    <li>
                                        {vOCContract.payment_step10}
                                    </li>
                                    :
                                    ('')
                            }
                        </ul>
                    </div>
                    <br/> <br/> <br/>

                    <Row style={{textAlign: 'center'}}>
                        <Col>
                            <h6 style={{borderTop: 'solid'}}>
                                <br/>
                                {vOCContract.authorized_signature1} | Proposal Accepted By (Authorized Signature)
                            </h6>
                        </Col>
                        <Col>
                            <h6 style={{borderTop: 'solid'}}>
                                <br/>
                                {vOCContract.proposal_submitted_by_signature1} | Proposal Submitted By
                            </h6>
                        </Col>
                    </Row>

                </div>

                <br/>
                <br/>
                <br/>

                <div style={{border: 'solid'}}>
                    <h4 style={{textAlign: 'center'}}>
                        Contractor pre-lien notice
                    </h4>
                    <h4 style={{paddingTop: '15px', textIndent: '5em'}}>
                        "(A) any person or company supplying labor or materials for this improvement to your property
                        may file a lien against your property if that person or company is not paid for the
                        contributions
                    </h4>
                    <h4 style={{paddingTop: '15px', textIndent: '5em'}}>
                        (B) under minnesota law, you have the right to pay persons who supplied labor or materials for
                        this improvement directly and deduct this amount from our contract price or withhold the amounts
                        due them from us until 120 days after completion of the improvement unless we give you a lien
                        waiver signed by persons who supplied any labor or material for the improvement and who gave
                        you timely notice"
                    </h4>

                    <br/><br/><br/><br/>

                    <Row style={{textAlign: "center"}}>
                        <Col>
                            <h6 style={{borderTop: 'solid'}}>
                                <br/>
                                {vOCContract.authorized_signature2} | Authorized signature & Date
                            </h6>
                        </Col>
                        <Col>
                            <h6 style={{borderTop: 'solid'}}>
                                <br/>
                                {vOCContract.proposal_submitted_by_signature2} | Home Safety Solutions Inc. & Date
                            </h6>
                        </Col>
                    </Row>
                </div>
            </div>

            <div style={{textAlign: "center", padding: '25px 0'}}>
                <Link className={'btn btn-primary'} to={`/voc_contracts/update/${vOCContract.id}/`}>Update Contract</Link>
                <p>Hit Ctr + P to print</p>
            </div>
        </div>
    );
}

export default DetailVocContract;